import { createSlice } from '@reduxjs/toolkit';
import { projectsActions } from './projects.actions';
var moment = require('moment-timezone');
moment.tz.setDefault("America/New_York");
export interface userState {
  value: any;
  status: 'idle' | 'loading' | 'failed';
}

// ------ Project Overview Reducer for managing Project overview state. ------
const projectsSlice = createSlice({
  name: "projects",
  initialState: {
    projectsListData: {},
    projectsActionItems: null,
    projectsPaymentData: {milestones: []},
    projectsGalleryData: [],
    projectCameraHash: "",
    projectCameraList: [],
    error: "",
    loading: false
  },
  reducers: {
    cleanCameraList: (state) => {
      state.projectCameraList = [];
    },
  },
  extraReducers: (builder) => {
    builder
       // -------- cases of projects Timeline api data -------
       .addCase(projectsActions.projectsTimeAction.pending, (state, action) => {
        state.error = "";
        state.projectsListData = {};
        state.loading = true;
      })
      .addCase(projectsActions.projectsTimeAction.fulfilled, (state, action) => {
        if(action?.payload?.data?.status === 200) {
          if(action?.payload?.data?.data){
            action.payload.data.data.items.map((ele: any) => {
              ele.end = moment(ele.end).endOf('day').subtract(1, "hour").valueOf();
              ele.start = moment(ele.start).startOf('day').valueOf();
              return 
            })
          }
          state.projectsListData= action.payload.data.data;
          state.error = "";
        } else {
          state.projectsListData = {};
          state.error = "Unable to fetch project timeline"
        }
      })
      .addCase(projectsActions.projectsTimeAction.rejected, (state, action:any) => {
        state.loading = false;
        state.projectsListData = {};
        state.error = action?.payload?.data?.message || "Unable to fetch project timeline";
      })
       // -------- cases of projects payments api data -------
       .addCase(projectsActions.projectsPaymentAction.pending, (state, action) => {
        state.error = "";
        state.projectsPaymentData = {milestones: []};
        state.loading = true;
      })
      .addCase(projectsActions.projectsPaymentAction.fulfilled, (state, action) => {
        if(action?.payload?.data?.status === 200) {
          state.projectsPaymentData = action.payload.data.data;
          state.error = "";
        } else {
          state.projectsPaymentData = {milestones: []};
          state.error = "Unable to fetch project payment data";
        }
          
      })
      .addCase(projectsActions.projectsPaymentAction.rejected, (state, action:any) => {
        state.loading = false;
        state.projectsPaymentData = {milestones: []};
        state.error = action?.payload?.data?.message || "Unable to fetch project payment data";
      })
       // -------- cases of projects Gallery api data -------
       .addCase(projectsActions.projectsGalleryAction.pending, (state, action) => {
        state.error = "";
        state.projectsGalleryData = [];
        state.loading = true;
      })
      .addCase(projectsActions.projectsGalleryAction.fulfilled, (state, action) => {
        if(action?.payload?.data?.status === 200) {
          state.projectsGalleryData = action.payload.data.data;
          state.error = "";
        } else {
          state.projectsGalleryData = [];
          state.error = "Unable to fetch project gallery";
        }
      })
      .addCase(projectsActions.projectsGalleryAction.rejected, (state, action:any) => {
        state.loading = false;
        state.projectsGalleryData = [];
        state.error = action?.payload?.data?.message || "Unable to fetch project gallery";
      })
       // -------- cases of projects Actoins api data -------
       .addCase(projectsActions.projectsPendingAction.pending, (state, action) => {
        state.error = "";
        state.projectsActionItems = null;
        state.loading = true;
      })
      .addCase(projectsActions.projectsPendingAction.fulfilled, (state, action) => {
        if(action?.payload?.data?.status === 200) {
          state.projectsActionItems = action.payload.data.data;
          state.error = "";
        } else {
          state.projectsActionItems = null;
          state.error = "Unable to fetch projects pending actions"
        }
      })
      .addCase(projectsActions.projectsPendingAction.rejected, (state, action:any) => {
        state.loading = false;
        state.projectsActionItems = null;
        state.error = action?.payload?.data?.message || "Unable to fetch projects pending actions";
      })

      // -------- cases of projects camera hash api data -------
      .addCase(projectsActions.getProjectCameraAction.pending, (state, action) => {
        state.error = "";
        // state.projectCameraList = [];
        state.projectCameraHash = "";
        state.loading = true;
      })
      .addCase(projectsActions.getProjectCameraAction.fulfilled, (state, action) => {
        if(action?.payload?.data?.status === 200) {
          // state.projectCameraList = action.payload.data.data;
          state.projectCameraHash = action.payload.data.data?.feedHash;
          localStorage.setItem("projectCameraHash", action.payload.data.data?.feedHash);
          state.error = "";
        } else {
          // state.projectCameraList = [];
          state.projectCameraHash = "";
          state.error = "Unable to fetch project camera list";
        }
      })
      .addCase(projectsActions.getProjectCameraAction.rejected, (state, action:any) => {
        state.loading = false;
        // state.projectCameraList = [];
        state.projectCameraHash = "";
        state.error = action?.payload?.data?.message || "Unable to fetch project camera list";
      })

      // -------- cases of projects camera urls api data -------
      .addCase(projectsActions.getProjectCameraFeedsAction.pending, (state, action) => {
        state.error = "";
        if(action?.meta?.arg?.reset){
          state.projectCameraList = [];
        }
        state.loading = true;
      })
      .addCase(projectsActions.getProjectCameraFeedsAction.fulfilled, (state, action) => {
        if(action?.payload?.data?.status === 200) {
          state.projectCameraList = action.payload.data.data;
          state.error = "";
        } else {
          state.projectCameraList = [];
          state.error = "Unable to fetch project camera list";
        }
        state.loading = false;
      })
      .addCase(projectsActions.getProjectCameraFeedsAction.rejected, (state, action:any) => {
        state.loading = false;
        state.projectCameraList = [];
        state.error = action?.payload?.data?.message || "Unable to fetch project camera list";
      })
  },
  
});

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
// export const token = (state: RootState) => state.login.token;

export const { cleanCameraList } = projectsSlice.actions;
export default projectsSlice.reducer;
